
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_62033_175)"}},[_c('path',{attrs:{"d":"M2.294 7.523v6.227h3.195V9.805a.75.75 0 01.75-.75h3.522a.75.75 0 01.75.75v3.945h3.195V7.523L8 1.817 2.294 7.523zM15.206 14.5a.75.75 0 01-.75.75H9.761a.75.75 0 01-.75-.75v-3.945H6.989V14.5a.75.75 0 01-.75.75H1.544a.75.75 0 01-.75-.75V7.457l.007-.13c.012-.131.044-.26.094-.382l.056-.119c.062-.115.14-.221.233-.314l5.87-5.87c.125-.124.272-.223.434-.29l.124-.044C7.738.27 7.868.25 8 .25l.132.007c.087.008.173.025.257.05l.123.045.119.056c.115.062.221.14.314.234l5.87 5.87.088.096c.056.068.104.141.146.218l.055.12.045.123c.038.126.057.256.057.388V14.5z","fill":"#4A4A4A"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_62033_175"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    